import { Text, View } from '@react-pdf/renderer';

import { styles } from '@/components/Contract/Download/style';

const Missouri = () => {
  return (
    <View style={styles.section}>
      <Text style={styles.title}>Missouri Specific Terms</Text>

      <View style={styles.list}>
        <Text style={styles.listItem}>
          1. Seller's Disclosure Statement: Standard practice, though not
          mandated.
        </Text>

        <Text style={styles.listItem}>
          2. Lead-Based Paint: Mandatory disclosure for homes built before 1978.
        </Text>

        <Text style={styles.listItem}>
          3. <Text style={styles.underline}>Lead-Based Paint Disclosure</Text> –
          Only for residences that were built before 1978. This information
          should be available at the County's Revenue Office.
        </Text>

        <Text style={styles.listItem}>
          4.{' '}
          <Text style={styles.underline}>
            General Property Condition Disclosure
          </Text>{' '}
          – Although not required, providing this disclosure can reassure buyers
          regarding the condition of the property.
        </Text>
      </View>
    </View>
  );
};

export default Missouri;
